import { getScheduleId, normalizeSchedules } from 'routes/Studies/routes/Study/routes/Instruments/utils/multiSchedule'

const isServerBackedScheduleDraft = (schedule, persistedId) => {
  if (!schedule || persistedId == null) return false
  const id = String(schedule.id || '')
  const scheduleId = String(schedule.scheduleId || '')
  const persisted = String(persistedId)
  return id === persisted || (scheduleId === persisted && id === scheduleId)
}

/** Server schedule_id for DELETE, or null when the draft was never persisted. */
export const resolvePersistedEngineScheduleId = (schedule, instrument) => {
  if (!schedule || !instrument?.metadata?.schedule) return null
  const entries = normalizeSchedules(instrument.metadata.schedule)
  const candidates = [schedule.scheduleId, schedule.id].filter(Boolean).map(String)
  const matched = entries.find(entry => candidates.includes(String(getScheduleId(entry))))
  if (!matched) return null
  const persistedId = getScheduleId(matched)
  return isServerBackedScheduleDraft(schedule, persistedId) ? persistedId : null
}

export { isServerBackedScheduleDraft }
